import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  { headerName: 'ID', field: 'patrolId', width: LIST_WIDTH.HUMAN_READABLE_ID },
  {
    headerName: 'Status',
    field: 'status',
    width: LIST_WIDTH.STATUS,
    cellRenderer: 'convertEventStatus',
  },
  {
    headerName: 'Business Client Name',
    field: 'businessClientName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  { headerName: 'Site Name', field: 'siteName', width: LIST_WIDTH.OBJECT_NAME },
  {
    headerName: 'Patrol Definition Name',
    field: 'patrolDefinitionName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Time started',
    field: 'timeStarted',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Patroller Name',
    field: 'patrollerName',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Elapsed Time',
    field: 'elapsedTime',
    width: LIST_WIDTH.ELAPSED_NUMBER,
  },
];
